var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Instant } from '@js-joda/core';
import { withDone } from '@rad/utility/http';
import { fetchInvoice } from '../../http/invoices';
import { fetchInspectionDetailForAdmin } from '../../http/inspections';
import { formatDate, formatInvoiceNumber } from '../../utility/formatters';
import Card from '../components/card';
import Button from '../components/button';
import Icon from '../components/icon';
import InspectionContent from '../components/inspection-content';
import CInspectionSend from '../components/modals/inspection-send';
export default (props) => {
    const [detail, setDetail] = React.useState(null);
    const [sendInvoice, setSendInvoice] = React.useState(null);
    const [sendOpen, setSendOpen] = React.useState(false);
    const [loadingSend, setLoadingSend] = React.useState(false);
    React.useEffect(() => {
        fetchInspectionDetailForAdmin(props.id, {
            'success': (data) => setDetail(data),
            'error': () => setDetail('error'),
        });
    }, [props.id]);
    if (detail === null) {
        return _jsx(Card, { title: "Inspection", children: _jsx("p", { className: "text-muted m-0", children: "Loading..." }) });
    }
    if (detail === 'error') {
        return _jsx(Card, { title: "Inspection", children: _jsx("p", { className: "text-danger m-0", children: "Inspection not found." }) });
    }
    const viewHref = `#/invoices/${detail.inspection.merchant_id}/${detail.inspection.invoice_id}`;
    const viewLabel = detail.invoice_classification === 'estimate' ? 'Estimate' : 'Repair Order';
    const statusBadge = detail.inspection.completed
        ? _jsx("span", { className: "badge bg-success", children: "Completed" })
        : _jsx("span", { className: "badge bg-warning text-dark", children: "In Progress" });
    const showSend = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoadingSend(true);
            setSendInvoice(yield withDone(fetchInvoice(detail.inspection.merchant_id, detail.inspection.invoice_id))());
            setSendOpen(true);
        }
        finally {
            setLoadingSend(false);
        }
    });
    return _jsxs(_Fragment, { children: [_jsx(CInspectionSend, { inspection: sendOpen && !!sendInvoice ? {
                    'id': detail.inspection.id,
                    'merchant_id': detail.inspection.merchant_id,
                    'invoice_id': detail.inspection.invoice_id,
                    'title': detail.inspection.title,
                } : null, contacts: (sendInvoice === null || sendInvoice === void 0 ? void 0 : sendInvoice.client.contacts) || [], onClose: () => setSendOpen(false) }), _jsxs("div", { className: "d-flex justify-content-between align-items-center mb-3 d-print-none", children: [_jsx("strong", { children: formatInvoiceNumber({ number: detail.invoice_number, classification: detail.invoice_classification }) }), _jsxs("div", { className: "d-flex gap-2", children: [_jsxs(Button, { color: "primary", onClick: () => { window.location.hash = viewHref; }, children: ["View ", viewLabel] }), _jsx(Button, { color: "success", onClick: showSend, disabled: loadingSend, title: "Send", children: _jsx(Icon, { size: "inherit", children: "send" }) }), _jsx(Button, { color: "secondary", onClick: () => window.print(), title: "Print", children: _jsx(Icon, { size: "inherit", children: "print" }) })] })] }), _jsxs(Card, { title: detail.inspection.title, children: [_jsx("div", { className: "mb-3", children: _jsxs("div", { className: "d-flex justify-content-between flex-wrap", children: [_jsxs("div", { children: [_jsxs("strong", { children: [detail.client_firstname, " ", detail.client_lastname] }), _jsxs("div", { className: "text-muted small", children: [detail.vehicle_kind || 'Vehicle', " \u00B7 VIN: ", detail.vehicle_vin || '—'] }), _jsxs("div", { className: "text-muted small", children: ["Technician: ", detail.performer_name, " \u00B7 ", formatDate(Instant.parse(detail.inspection.created))] })] }), _jsx("div", { children: statusBadge })] }) }), _jsx(InspectionContent, { detail: detail, showHeader: false })] })] });
};
